import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Home, BookOpen, FileText, Eye } from 'lucide-react';
import { codesPracticeDocuments } from '../data/pdfDocuments';
import PVSPageLayout from './PVSPageLayout';

const COPViewer = ({ onReturnHome }) => {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('All');
  
  // Get unique categories
  const categories = ['All', ...new Set(codesPracticeDocuments.map(doc => doc.category))];
  
  // Filter documents by category
  const filteredDocuments = selectedCategory === 'All' 
    ? codesPracticeDocuments 
    : codesPracticeDocuments.filter(doc => doc.category === selectedCategory);

  const handleViewPdf = (pdfDoc) => {
    // Navigate to the PDF viewer with the document ID
    navigate(`/viewer/${pdfDoc.id}`);
  };

  return (
    <PVSPageLayout className="py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="pvs-glass w-full">
          <div className="border-b border-pvs-border p-6">
            <div className="flex justify-between items-center gap-4 mb-6">
              <h1 className="text-2xl sm:text-3xl font-bold text-white flex-1 min-w-0">Codes of Practice</h1>
              <button
                className="flex items-center justify-center w-12 h-12 flex-shrink-0 pvs-glass pvs-glass-hover"
                onClick={onReturnHome}
                title="Return to Homepage"
              >
                <Home className="w-6 h-6" stroke="url(#icon-two-tone)" />
              </button>
            </div>
            
            {/* Category Filter */}
            <div className="flex flex-wrap gap-2">
              {categories.map(category => (
                <button
                  key={category}
                  onClick={() => setSelectedCategory(category)}
                  className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    selectedCategory === category
                      ? 'bg-pvs-accent text-pvs-bg shadow-pvs-glow'
                      : 'bg-pvs-card-light text-pvs-text-muted border border-pvs-border hover:border-pvs-accent/30'
                  }`}
                >
                  {category}
                </button>
              ))}
            </div>
          </div>
          
          <div className="p-6">
            {filteredDocuments.length > 0 ? (
              <div className="grid gap-4">
                {filteredDocuments.map(pdfDoc => (
                  <div key={pdfDoc.id} className="border border-pvs-border rounded-lg p-4 hover:border-pvs-accent/30 hover:shadow-pvs-glow transition-all duration-200">
                    <div className="flex items-start justify-between">
                      <div className="flex-1">
                        <div className="flex items-center gap-3 mb-2">
                          <FileText className="h-5 w-5 text-pvs-accent" />
                          <h3 className="text-lg font-semibold text-white">{pdfDoc.title}</h3>
                          <span className="px-2 py-1 bg-pvs-card-light text-pvs-text-muted text-xs rounded-full border border-pvs-border">
                            {pdfDoc.category}
                          </span>
                        </div>
                        <p className="text-pvs-text-muted text-sm mb-3">{pdfDoc.description}</p>
                      </div>
                      
                      <div className="flex gap-2 ml-4">
                        <button
                          onClick={() => handleViewPdf(pdfDoc)}
                          className="flex items-center gap-2 px-3 py-2 pvs-btn-accent rounded-lg text-sm"
                          title="View PDF"
                        >
                          <Eye className="h-4 w-4" />
                          View
                        </button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <div className="text-center py-12">
                <BookOpen className="mx-auto h-24 w-24 text-pvs-text-dim mb-4" />
                <h3 className="text-lg font-medium text-white mb-2">No Documents Found</h3>
                <p className="text-pvs-text-muted">
                  No documents found in the {selectedCategory} category.
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </PVSPageLayout>
  );
};

export default COPViewer;
